import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapProjectsLocations = {
  show: async(props) => {
    const { default: LocationDetail } = await import('@/vue_widgets/mlap/location/index.vue')
    createVueApp(LocationDetail, { props })
  }
}
